
  <section class="page-banner-sec" [style.background-image]="'url(' + (pageData?.image ? pageData?.image  :'assets/img/career-page-banner.png') + ')'" >
    <div class="container">
        <h1 class="page-banner-title">{{pageData?.title}}</h1>
    </div>
  </section>

  <section class="py-5">
     <div class="container">
        <div  class="text-76" [innerHtml]="pageData?.description"></div>

         <div class="row two-part-img-text my-5">
             <div class="col-lg-6"><div class="part-img">
                 <img [src]="pageData?.jsonKey[0]?.content[0]?.image? pageData?.jsonKey[0]?.content[0]?.image:'assets/img/car-fooprint.png'" class="img-responsive">
                </div>
            </div>
            <div class="col-lg-6">
                <div class="part-text">
                    <h2 class="font-weight-bold">{{pageData?.jsonKey[0]?.content[0]?.title}}</h2>
                  <div  class="text-76" [innerHtml]="pageData?.jsonKey[0]?.content[0]?.description"></div>

                  </div>
            </div>
        </div>
     </div>
  </section>

  <section class="py-5 currunt-opening-sec">
      <div class="container">
        <h2 class="font-weight-bold text-center mb-4">Current Openings</h2>
        <div class="row">

            <div class="col-xl-3 col-lg-4 col-sm-6" *ngFor="let opening of jobData">
                <div class="currunt-opening-box">
                    <h3>{{opening.title}}</h3>
                    <p>{{opening.description.length < 100 ? opening.description : opening.description.slice(0,100)+'...'}}</p>
                    <label>Post: {{opening.post}}</label>
                    <label>Experience: {{opening.experience}}</label>
                    <label>Location: {{opening.location}}</label>
                    <div class="mt-3">
                        <button class="btn btn-primary shadow-none font-weight-bold" [routerLink]="['/career-detail', opening._id ]">Apply Now</button>
                    </div>
                </div>
            </div>


        </div>
      </div>
  </section>

